/**
 * @file コンポーネント：共通フッター DOM管理
 */

// ライブラリ読み込み
import React from "react";

// コンポーネント読み込み
import { Newslist } from "~/src/components/projects/Newslist";
import { Partnerlist } from "~/src/components/projects/Partnerlist";

// スタイル読み込み
import {
    StyledFooter,
    StyledFooterBottomContainer,
    StyledFooterBottomSection,
    StyledFooterBottomGeoLite2Text,
    StyledFooterContainer,
    StyledFooterCopyright,
    StyledFooterHeadline,
    StyledFooterLogo,
    StyledFooterLogoImage,
    StyledFooterLogoText,
    StyledFooterSection,
    StyledFooterSectionAnchor,
    StyledFooterSectionFull,
    StyledFooterSectionHeadline,
    StyledFooterSectionHeadlineBorder,
    StyledFooterSectionList,
    StyledFooterSectionListItem,
    StyledFooterUnderlineText,
} from "./style";

// Presenterを返す
export const Presenter = (props) => {
    // ローカライズデータ
    const localized = window.listLocalized;

    // ReactDOM
    return (
        <StyledFooter>
            <StyledFooterHeadline>
                {localized["Label.SiteMenu"]}
            </StyledFooterHeadline>
            <StyledFooterContainer>
                {!props.isSponsorUser && ( // スポンサーユーザー以外の場合
                    // 新着情報
                    <StyledFooterSectionFull>
                        <StyledFooterSectionHeadline>
                            {localized["Label.News"]}
                        </StyledFooterSectionHeadline>
                        <Newslist />
                    </StyledFooterSectionFull>
                )}
                {!props.isSponsorUser &&
                    props.partnerlist.length > 0 && ( // スポンサーユーザー以外かつ協賛企業が1件以上ある場合
                        // 協賛企業
                        <StyledFooterSection>
                            <StyledFooterSectionHeadlineBorder>
                                {localized["Label.IndustrialPartners"]}
                            </StyledFooterSectionHeadlineBorder>
                            <Partnerlist list={props.partnerlist} />
                        </StyledFooterSection>
                    )}
            </StyledFooterContainer>
            <StyledFooterBottomContainer>
                <StyledFooterBottomSection>
                    {/* GeoLite2 License */}
                    <StyledFooterBottomGeoLite2Text>
                        This product includes GeoLite2 data created by {/*eslint-disable-line*/}
                        <StyledFooterSectionAnchor
                            href="https://www.maxmind.com"
                            target="_blank"
                        >
                            <StyledFooterUnderlineText>
                                MaxMind
                            </StyledFooterUnderlineText>
                        </StyledFooterSectionAnchor>
                    </StyledFooterBottomGeoLite2Text>
                </StyledFooterBottomSection>
                <StyledFooterBottomSection>
                    {/* 会社ロゴ */}
                    <StyledFooterLogo>
                        <StyledFooterLogoImage
                            alt={localized["Label.CompanyName"]}
                            height="34"
                            src="/assets/images/logo-company.png"
                            width="107"
                        />
                    </StyledFooterLogo>
                    {/* コピーライト */}
                    <StyledFooterCopyright>
                        Copyright 2019 OPExPARK Inc. All Rights Reserved.
                    </StyledFooterCopyright>
                </StyledFooterBottomSection>
            </StyledFooterBottomContainer>
        </StyledFooter>
    );
};
